var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warp"},[_c('TabList',{attrs:{"props-obj":_vm.propsObj,"wd":_vm.wd,"search-click":_vm.searchClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }